import React from "react";
import "./index.css";
import { motion } from "framer-motion";
import { adds } from "../../../assets";

const Medios = ({ variants }) => {
  return (
    <div className="mediosDiv flex flexCol gap">
      <img className="blur blur2" src={adds.blur1} alt="Blur" />

      <motion.div
        variants={variants}
        initial={"initial"}
        whileInView={"ani"}
        viewport={{ once: true }}
        custom={0.3}
        className="flex flexCol"
      >
        <h4>Email</h4>
        <a href="mailto:hello@replace.com.ar" target="_blank" rel="noreferrer">
          <p>hello@replace.com.ar</p>
        </a>
      </motion.div>
      <motion.div
        variants={variants}
        initial={"initial"}
        whileInView={"ani"}
        viewport={{ once: true }}
        custom={0.5}
        className="flex flexCol"
      >
        <h4>Teléfono</h4>
        <a href="tel:+542235064735">
          <p>+54 223 506 4735</p>
        </a>
      </motion.div>
      <motion.div
        variants={variants}
        initial={"initial"}
        whileInView={"ani"}
        viewport={{ once: true }}
        custom={0.7}
        className="flex flexCol"
      >
        <h4>Dirección</h4>
        <p>Argentina,</p>
        <p>Buenos Aires,</p>
        <p>San Juan 2853</p>
      </motion.div>
    </div>
  );
};

export default Medios;
